<template>
  <div class="dataProject">
    <div class="body-content-title">
        <div class="title">NQI十三五成果</div>
    </div>
    <div class="body" style="position: relative;z-index: 0;">
        <div class="body-content">
            <div class="body-result">
                <result></result>
            </div>
            <div class="body-map">
              <div class="left-fixed">
                <ul>
                  <li v-for="(type, index) in countList" v-if="index<(countList.length/2)" :key="index">
                    {{type.unit_type}}：{{type.rs}}
                  </li>
                </ul>
              </div>
                <mapCount></mapCount>
              <div class="right-fixed">
                <ul>
                  <li v-for="(type, index) in countList" v-if="index>=(countList.length/2)" :key="index">
                    {{type.unit_type}}：{{type.rs}}
                  </li>
                </ul>
              </div>
            </div>
            <div class="body-project">
                <div class="pro">
                    <projectCount></projectCount>
                </div>
                <div class="fund">
                    <fundCount></fundCount>
                </div>
            </div>
        </div>
        <div class="body-content" style="padding-top:20px;">
            <div class="body-bottom">
                <paper></paper>
            </div>
            <div class="body-bottom" style="margin:0px 20px;">
                <patent></patent>
            </div>
            <div class="body-bottom" style="margin-right: 20px;">
                <standard></standard>
            </div>
            <div class="body-bottom">
                <talent></talent>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import result from '../../components/result.vue'
import projectCount from '../../components/projectCount.vue'
import fundCount from '../../components/fundCount.vue'
import paper from '../../components/paper.vue'
import patent from '../../components/patent.vue'
import standard from '../../components/standard.vue'
import talent from '../../components/talent.vue'
import mapCount from '../../components/mapCount.vue'
export default {
  components: {
    result,
    projectCount,
    paper,
    fundCount,
    patent,
    standard,
    talent,
    mapCount
  },
  data () {
    return {
      countList: []
    }
  },
  mounted () {
    this.fetchCount();
  },
  methods: {
    fetchCount () {
      this.post('/dataapi/open/nqi/fruit/countByType').then(res => {
        this.countList = res.result;
      })
    }
  }
}
</script>
<style lang="less" scoped>
.dataProject {
  width: 100%;
  margin: 0 auto;
  background:  #03050C;
}
.body-content-title {
  height: 60px;
  width: 100%;
  background: url('../../assets/images/databack.png') no-repeat;
  background-size: 100%;
  background-position: center 0;
  padding-top: 15px;
  .title{
    margin: 0px auto;
    width: 150px;
    height: 29px;
    font-size: 21px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 29px;
  }
}
.body{
    padding: 30px 20px;
}
.body-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .body-result{
    width: 24%;
    height: 500px;
  }
  .body-project{
    width: 24%;
    height: 500px;
      .pro{
        width: 100%;
        height: 240px;
        margin-bottom: 20px;
      }
      .fund{
        width: 100%;
        height: 240px;
      }
  }
  .body-map{
    flex: 2;
    height: 500px;
    margin: 0 20px;
    position: relative;
    .left-fixed {
      position: absolute;
      z-index: 999;
      color: #fff;
      left: 4px;
      top: 4px;
      width: 176px;
      padding: 20px;
      background-image: url('../../assets/images/contentBg-min.png');
      background-size: 100% 100%;
      li {
        line-height: 24px;
      }
    }
    .right-fixed {
      position: absolute;
      z-index: 999;
      color: #fff;
      right: 4px;
      top: 4px;
      padding: 20px;
      width: 176px;
      background-image: url('../../assets/images/contentBg-min.png');
      background-size: 100% 100%;
      li {
        line-height: 24px;
      }
    }
  }
  .body-bottom{
    height: 250px;
    width: 24%;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/dataAssemble/index.vue